const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.120968,0,0,0.120968,0,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 263.2,
    cy: 211.6,
    r: 41.6,
    style: {
      fill: "rgb(239,145,34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.6,211.6C221.6,188.4 240,170 263.2,170C286.4,170 304.8,188.4 304.8,211.6C304.8,234.8 286.4,253.2 263.2,253.2",
    style: {
      fill: "rgb(242,110,33)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.4,182C250.4,166 276.8,166 292.8,182C308.8,198 308.8,224.4 292.8,240.4",
    style: {
      fill: "rgb(244,69,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4,172.4L0,172.4L0,250.8L22.4,250.8C34.4,250.8 43.2,247.6 50.4,242C59.2,234.8 64.8,223.6 64.8,211.6C64.8,188.4 48,172.4 22.4,172.4ZM40.8,231.6C36,235.6 29.6,238 20,238L15.2,238L15.2,186L19.2,186C28.8,186 35.2,187.6 40,192.4C45.6,197.2 48.8,204.4 48.8,211.6C49.6,218.8 46.4,226.8 40.8,231.6Z",
    style: {
      fill: "rgb(89,90,91)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0",
    x: 72,
    y: 172.4,
    width: 15.2,
    height: 78.4,
    style: {
      fill: "rgb(89,90,91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6,202.8C116,199.6 113.6,197.2 113.6,193.2C113.6,188.4 118.4,184.4 124.8,184.4C129.6,184.4 133.6,186 137.6,190.8L145.6,180.4C139.2,174.8 131.2,171.6 122.4,171.6C108.8,171.6 97.6,181.2 97.6,194C97.6,205.2 102.4,210 116.8,215.6C123.2,218 125.6,218.8 127.2,220.4C130.4,222 132,225.2 132,228.4C132,234.8 127.2,239.6 120,239.6C112.8,239.6 106.4,235.6 103.2,229.2L93.6,238.8C100.8,249.2 109.6,254 120.8,254C136.8,254 148,243.6 148,228.4C148,214.8 143.2,209.2 125.6,202.8Z",
    style: {
      fill: "rgb(89,90,91)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.8,211.6C152.8,234.8 171.2,252.4 194.4,252.4C200.8,252.4 206.4,250.8 213.6,247.6L213.6,229.2C207.2,235.6 201.6,238 195.2,238C180,238 168.8,226.8 168.8,210.8C168.8,195.6 180,183.6 194.4,183.6C201.6,183.6 207.2,186 213.6,192.4L213.6,174C207.2,170.8 201.6,169.2 194.4,169.2C172,170.8 152.8,189.2 152.8,211.6Z",
    style: {
      fill: "rgb(59,61,63)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.2,225.2L318.4,172.4L301.6,172.4L334.4,253.2L343.2,253.2L377.6,172.4L360.8,172.4L339.2,225.2Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,250.8L428,250.8L428,238L400,238L400,216.4L427.2,216.4L427.2,202.8L400,202.8L400,186L428,186L428,172.4L384,172.4L384,250.8Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M471.2,218C483.2,215.6 489.6,207.6 489.6,195.6C489.6,181.2 479.2,172.4 461.6,172.4L438.4,172.4L438.4,250.8L453.6,250.8L453.6,219.6L456,219.6L477.6,250.8L496,250.8L471.2,218ZM458.4,208.4L453.6,208.4L453.6,184.4L458.4,184.4C468,184.4 473.6,188.4 473.6,196.4C473.6,204.4 468,208.4 458.4,208.4Z",
    style: {
      fill: "rgb(89,90,91)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4,172.4L0,172.4L0,250.8L22.4,250.8C34.4,250.8 43.2,247.6 50.4,242C59.2,234.8 64.8,223.6 64.8,211.6C64.8,188.4 48,172.4 22.4,172.4ZM40.8,231.6C36,235.6 29.6,238 20,238L15.2,238L15.2,186L19.2,186C28.8,186 35.2,187.6 40,192.4C45.6,197.2 48.8,204.4 48.8,211.6C49.6,218.8 46.4,226.8 40.8,231.6Z",
    style: {
      fill: "rgb(89,90,91)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0_1_",
    x: 72,
    y: 172.4,
    width: 15.2,
    height: 78.4,
    style: {
      fill: "rgb(89,90,91)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.6,202.8C116,199.6 113.6,197.2 113.6,193.2C113.6,188.4 118.4,184.4 124.8,184.4C129.6,184.4 133.6,186 137.6,190.8L145.6,180.4C139.2,174.8 131.2,171.6 122.4,171.6C108.8,171.6 97.6,181.2 97.6,194C97.6,205.2 102.4,210 116.8,215.6C123.2,218 125.6,218.8 127.2,220.4C130.4,222 132,225.2 132,228.4C132,234.8 127.2,239.6 120,239.6C112.8,239.6 106.4,235.6 103.2,229.2L93.6,238.8C100.8,249.2 109.6,254 120.8,254C136.8,254 148,243.6 148,228.4C148,214.8 143.2,209.2 125.6,202.8Z",
    style: {
      fill: "rgb(89,90,91)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.2,252.4C201.6,252.4 207.2,250.8 214.4,247.6L214.4,229.2C208,235.6 202.4,238 196,238C180.8,238 169.6,226.8 169.6,210.8C169.6,202.8 172.8,196.4 177.6,190.8L167.2,180.4C159.2,187.6 153.6,198.8 153.6,210.8C152.8,234.8 171.2,252.4 195.2,252.4Z",
    style: {
      fill: "rgb(89,90,91)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M471.2,218C483.2,215.6 489.6,207.6 489.6,195.6C489.6,181.2 479.2,172.4 461.6,172.4L438.4,172.4L438.4,250.8L453.6,250.8L453.6,219.6L456,219.6L477.6,250.8L496,250.8L471.2,218ZM458.4,208.4L453.6,208.4L453.6,184.4L458.4,184.4C468,184.4 473.6,188.4 473.6,196.4C473.6,204.4 468,208.4 458.4,208.4Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.8,323.6L112.8,279.6L143.2,310.8L143.2,282L149.6,282L149.6,326L119.2,294.8L119.2,323.6L112.8,323.6Z",
    style: {
      fill: "rgb(242,110,33)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.6,288.4L164.8,288.4L164.8,298L180.8,298L180.8,304.4L164.8,304.4L164.8,318L181.6,318L181.6,323.6L158.4,323.6L158.4,282L181.6,282L181.6,288.4Z",
    style: {
      fill: "rgb(242,110,33)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.6,288.4L201.6,323.6L195.2,323.6L195.2,288.4L185.6,288.4L185.6,282.8L211.2,282.8L211.2,288.4L201.6,288.4Z",
    style: {
      fill: "rgb(242,110,33)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.8,282.8L231.2,310.8L242.4,281.2L252.8,310.8L264,282.8L272,282.8L253.6,326.8L243.2,297.2L232,326.8L214.4,282.8L220.8,282.8Z",
    style: {
      fill: "rgb(242,110,33)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.8,302.8C272.8,297.2 275.2,291.6 279.2,287.6C283.2,283.6 288.8,281.2 294.4,281.2C300,281.2 305.6,283.6 309.6,287.6C313.6,291.6 316,297.2 316,302.8C316,308.4 313.6,314 309.6,318C305.6,322 300,324.4 294.4,324.4C288.8,324.4 284,322.8 280,318.8C275.2,314.8 272.8,310 272.8,302.8ZM279.2,302.8C279.2,307.6 280.8,310.8 284,314C287.2,317.2 290.4,318.8 294.4,318.8C298.4,318.8 302.4,317.2 305.6,314C308.8,310.8 310.4,307.6 310.4,302.8C310.4,298 308.8,294.8 305.6,291.6C302.4,288.4 299.2,286.8 294.4,286.8C290.4,286.8 286.4,288.4 283.2,291.6C280.8,294.8 279.2,298.8 279.2,302.8Z",
    style: {
      fill: "rgb(242,110,33)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.4,306L351.2,323.6L343.2,323.6L331.2,306.8L330.4,306.8L330.4,323.6L324,323.6L324,282L331.2,282C336.8,282 340.8,282.8 343.2,285.2C345.6,287.6 347.2,290.8 347.2,294C347.2,297.2 346.4,299.6 344.8,301.2C343.2,304.4 340.8,306 338.4,306ZM330.4,301.2L332,301.2C337.6,301.2 340.8,298.8 340.8,294.8C340.8,290.8 337.6,288.4 332,288.4L329.6,288.4L329.6,301.2L330.4,301.2Z",
    style: {
      fill: "rgb(242,110,33)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.2,298.8L379.2,282L387.2,282L368.8,300.4L387.2,322.8L379.2,322.8L364,304.4L362.4,306L362.4,322.8L356,322.8L356,281.2L362.4,281.2L362.4,298.8L363.2,298.8Z",
    style: {
      fill: "rgb(242,110,33)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M414.4,238L400,238L400,223.6L384,207.6L384,250.8L427.2,250.8L414.4,238Z",
    style: {
      fill: "rgb(59,61,63)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.8,180.4L339.2,225.2L318.4,172.4L301.6,172.4L334.4,253.2L343.2,253.2L368.8,192.4L356.8,180.4Z",
    style: {
      fill: "rgb(59,61,63)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.b0aa99b72295711c41083085da14df42.svg";
export { ForwardRef as ReactComponent };